import React from 'react';
import cn from 'classnames';
import { number, string, node, oneOfType } from 'prop-types';
import FormGroupContext from '../../context/FormGroupContext';
/**
 * FormGroup component.
 */

var FormGroup = function FormGroup(_ref) {
  var inputId = _ref.inputId,
      feedbackId = _ref.feedbackId,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(FormGroupContext.Provider, {
    value: {
      inputId: inputId,
      feedbackId: feedbackId
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('form-group', className)
  }, children));
};

FormGroup.defaultProps = {
  className: null,
  inputId: null,
  feedbackId: null,
  children: null
};
FormGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Form group inputId that is passed to children. */
  inputId: oneOfType([number, string]),

  /** An id used to link the form input to any feedback and provide improved accessability. */
  feedbackId: oneOfType([number, string]),

  /** Additional class names to add to the component root. */
  className: string,

  /** Form group children. */
  children: node
} : {};
export default FormGroup;